export const BATCH_PROCESSES_URL = '/api/v1/batch/processes';
export const IMMAP_PROCESS_URL = '/api/v1/immap/process';
export const BATCH_ASSETS_URL = '/api/v1/batch/assets';
export const BATCH_PROFILES_URL = '/api/v1/batch/profiles';
export const BATCH_MAPPINGS_URL = '/api/v1/batch/mappings';
export const BATCH_TARGETS_URL = '/api/v1/batch/targets';
export const BATCH_EXPORT_ERROR_URL = '/api/v1/batch/export/error';
export const BATCH_EXPORT_URL = '/api/v1/batch/export';
export const BATCH_GET_CALC_TYPES = '/api/v1/batch/calc-types';
export const PREVIEW_FILE_ROWS = 'previewFileRows';
export const TEMPLATE_COMPATIBILITY_ERROR_MESSAGE =
	'File content does not match template. Please update template or file and try again.';
export const TEMPLATE_COLUMNS_ERROR_MESSAGE =
	'File contains a formatting error that prevents processing with a custom template. Please update the file and try again.';
export const IMPORT_PROCESS_STATE = {
	UPLOADING: 0,
	MATCHING: 1,
	PROCESSING: 2,
	COMPLETE: 3,
	COMPLETE_WITH_ERRORS: 4,
	ERROR: 5,
	RETRY: 6,
	GLOBAL_TEMPLATE_EDIT: 7,
	MAX_LIMIT_EXCEEDED: 8,
};
export const DEFAULT_ADVANCED_OPTIONS = {
	dateFormat: 'MM/dd/yyyy',
	decimalSymbol: '.',
	thousandSeparator: ',',
	calculationType: 5,
	transactionType: 1,
	ruleType: '',
};
export const INITIAL_STATE = {
	selectedTemplate: {
		id: '',
		name: '',
		ruleType: '',
		calculationType: 5,
		dateFormat: 'MM/dd/yyyy',
		transactionType: 1,
		mapping: {
			id: '',
		},
	},
	fileId: null,
	fileName: null,
	processStatus: IMPORT_PROCESS_STATE.UPLOADING,
	processId: '',
	mappedColumns: [],
	allTemplatesFetched: [],
	selectedCustomTemplate: { id: '', name: '' },
	haveExtraRows: false,
	advancedOptions: DEFAULT_ADVANCED_OPTIONS,
};

export const DEFAULT_TEMPLATE_INFO = {
	id: '',
	name: '',
	mappingId: '',
	scope: '',
	columnDelimiter: ',',
	stripCurrencySymbols: '$',
	description: null,
	status: 'ACTIVE',
	version: 1,
	workflow: null,
};
